import type { AppointmentSlot } from '@/common/api/models/appointmentSlot';
import type { Booking } from '@/common/api/models/booking';
import { VideoMeetingProvider } from '@/common/api/models/videoMeetingProvider';

type VideoMeetingFields = {
  videoMeetingProvider?: string | null;
  videoMeetingJoinUrl?: string | null;
};

/**
 * Backward-compat for slots/bookings created before `videoMeetingProvider` was stamped.
 * Remove after historical data audit confirms all LiveKit records carry the provider.
 */
function isLegacyLiveKitJoinUrl(videoMeetingJoinUrl?: string | null): boolean {
  const join = videoMeetingJoinUrl ?? '';
  return Boolean(join)
    && join.includes('/student/courses')
    && !join.includes('teams.microsoft.com');
}

/** True when the entity was provisioned with LiveKit (not Teams). */
export function isLiveKitVideoMeeting(entity?: VideoMeetingFields | null): boolean {
  if (!entity) return false;

  if (entity.videoMeetingProvider === VideoMeetingProvider.livekit) {
    return true;
  }
  if (
    entity.videoMeetingProvider === VideoMeetingProvider.teams
    || entity.videoMeetingProvider === VideoMeetingProvider.none
  ) {
    return false;
  }

  if (entity.videoMeetingProvider == null) {
    return isLegacyLiveKitJoinUrl(entity.videoMeetingJoinUrl);
  }

  return false;
}

export function isLiveKitSlot(slot?: AppointmentSlot | null): boolean {
  return isLiveKitVideoMeeting(slot);
}

export function isLiveKitBooking(booking?: Booking | null): boolean {
  return isLiveKitVideoMeeting(booking);
}
